import { Flex, Text, useDisclosure } from "@chakra-ui/react";
import { TrackStats } from "api/generated/graphql";
import { FusionCarStats } from "components/Salvage/new/FusionCarStats";
import { IconInfoAccordion } from "icons";
import SuggestedStatsModal from "components/Modals/SuggestedStatsModal/SuggestedStatsModal";

const OptimalStats = ({ raceLevel, stats }: { raceLevel: number, stats: TrackStats[] }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Flex w="full" flexDir="column" gap="2" pb="4">
      <Flex
        background="linear-gradient(270deg, rgba(255, 53, 57, 0) 0%, rgba(255, 53, 57, 0.096) 50%, rgba(255, 53, 57, 0) 100%)"
        p="2"
        borderTopRadius="40px"
        position="relative"
        alignItems="center"
        justifyContent="center"
        gap="2"
        _before={{
          content: '""',
          position: 'absolute',
          inset: 0,
          padding: '0px',
          paddingBottom: '2px',
          background: 'linear-gradient(270deg, rgba(255, 53, 57, 0) 0%, rgba(255, 53, 57, 0.096) 50%, rgba(255, 53, 57, 0) 100%)',
          mask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
          maskComposite: 'exclude',
          zIndex: -1,
        }}
        onClick={onOpen}
      >
        <Text
          color="bloodMoon.100"
          fontSize={{ base: '0.75rem', md: '0.875rem' }}
          lineHeight="120%"
          fontWeight="400"
          fontFamily="heading"
          textTransform="uppercase"
        >
          Suggested Stats
        </Text>
        <IconInfoAccordion 
          width="0.75rem"
          height="0.75rem"
          onClick={onOpen}
          cursor="pointer"
          __css={{
            path: {
              fill: 'bloodMoon.100',
            },
          }}
        />
      </Flex>

      <FusionCarStats 
        stats={{
          handling: {
            bars: stats[0].handling,
          },
          speed: {
            bars: stats[0].speed,
          },
          fastTurns: {
            bars: stats[0].fastTurns,
          },
          slowTurns: {
            bars: stats[0].slowTurns,
          },
          braking: {
            bars: stats[0].braking,
          },
          cooling: {
            bars: stats[0].cooling,
          },
          acceleration: {
            bars: stats[0].acceleration,
          },
          stability: {
            bars: stats[0].stability,
          },
        }}
        carLevel={raceLevel + 1}
      />

      <SuggestedStatsModal
        isOpen={isOpen}
        onClose={onClose}
      />
    </Flex>
  );
};

export default OptimalStats;
